import { api } from "./apis";
import {
  fetchWithTimeout,
  fetchJson,
  fetchExternal,
  assertHttpOk,
  parseJsonSafe,
  getDefaultTimeoutMs,
  getGeoIpTimeoutMs,
  getGeoIpUrl,
  getDataTransactionUrl,
  getRouteEmailUrl,
  getSecureTimeoutMs,
} from "./httpClient";
import { createIntegrationError, ERROR_TYPES } from "./integrationErrors";
import {
  REACT_APP_API_URL,
  REACT_APP_DOMINIO,
  REACT_APP_DOMINIO_CONFIGURADO,
  REACT_APP_DEV,
} from "../../config/env";

const baseUrl = REACT_APP_API_URL;
let dominio = REACT_APP_DOMINIO;
let subdomain = "";
if (REACT_APP_DEV === "false") {
  subdomain = `${"https:"}//${window.location.hostname}`;
} else if ("true") {
  subdomain = REACT_APP_DOMINIO_CONFIGURADO;
}
let aux = 0;
let tokenRetryCount = 0;

const executeFetch = (url, options, timeoutMs = getDefaultTimeoutMs()) => {
  return fetchWithTimeout(url, options, timeoutMs)
    .then(assertHttpOk)
    .then(parseJsonSafe);
};


const normalizeTokenDomain = (rawDomain) => {
  try {
    const parsed = new URL(rawDomain);
    if (parsed.hostname.endsWith("epayco.me")) {
      return rawDomain;
    }

    if (parsed.hostname.includes(".recaudo-landing-green.epayco.co")) {
      const sub = parsed.hostname.split(".")[0];
      return `${parsed.protocol}//${sub}.epayco.me`;
    }

    return rawDomain;
  } catch (e) {
    return rawDomain;
  }
};

const tokenApi = (data, url, method, file) => {
  const MAX_TOKEN_RETRIES = 5;
  
  aux++;
  let option = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ dominio: normalizeTokenDomain(subdomain) }),
  };
  return new Promise((resolve, reject) => {
    executeFetch(baseUrl + api.token, option)
      .then((response) => {
        if (response.success) {
          sessionStorage.setItem("token", response.data.token);
          resolve(serviceApiResponse(data, url, method, file));
        } else {
          if (tokenRetryCount < MAX_TOKEN_RETRIES) {
            tokenRetryCount++;
            return tokenApi(data, url, method, file);
          } else {
            return reject(
              createIntegrationError(ERROR_TYPES.UNKNOWN, {
                endpoint: api.token,
                backendMessage: response.text_response,
              })
            );
          }
        }
      })
      .catch((error) => {
        if(tokenRetryCount < MAX_TOKEN_RETRIES){
          tokenRetryCount++;
          return tokenApi(data, url, method, file);
        } else {
          reject(error);
        }
      });
  });
};

const serviceApiGet = (url, timeoutMs = getGeoIpTimeoutMs()) => {
  return fetchJson(url, {}, timeoutMs);
};

const serviceApiPost = (url, params, timeoutMs = getDefaultTimeoutMs()) => {
  return fetchJson(
    url,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    },
    timeoutMs
  );
};

const serviceApi = (data, url, method, file) => {
  aux++;
  let option = {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  return executeFetch(url, option);
};

const serviceApiResponse = (data, url, method, file = false) => {
  if (!ValidateToken()) {
    return tokenApi(data, url, method, file);
  } else {
    let path = window.location.pathname;
    let paths = path.split("/");
    let proyect = "";
    
    if (paths.length > 2) {
      if (paths[1] === "recaudo") {
        sessionStorage.setItem("proyecto", paths[2]);
        proyect = `/${paths[1]}/${paths[2]}`;
        dominio = `${subdomain}${proyect}`;
        data.dominio = dominio;
    
        let options = {
          method,
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": file ? "multipart/form-data" : "application/json",
          },
          body: JSON.stringify(data),
        };
        return executeFetch(baseUrl + url, options);
      } else {
        sessionStorage.clear();
        return new Promise((resolve) => {
          resolve({
            success: false,
            data: [],
            text_response:
              "Ocurrió un error al configurar. Por favor intente más tarde",
            error_pathname: true,
          });
        });
      }
    } else {
      if (path[0] && path[0] === "recaudo") {
        sessionStorage.clear();
        return new Promise((resolve) => {
          resolve({
            success: false,
            data: [],
            text_response:
              "Ocurrió un error al configurar. Por favor intente más tarde",
            error_pathname: true,
          });
        });
      }
    }
  }
};

const parseJwt = () => {
  let token = sessionStorage.getItem("token");
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload).public_key;
};

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

const parseJwtToken = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};
const ValidateToken = () => {
  let token = sessionStorage.getItem("token");
  if(token){
    const decodedToken = parseJwtToken(token);
    const dateNow = new Date();
    if(decodedToken.exp > dateNow.getTime() / 1000){
      return true;
    }
  }
  return false;
};
export {
  serviceApiResponse,
  parseJwt,
  b64toBlob,
  serviceApi,
  serviceApiGet,
  serviceApiPost,
  ValidateToken,
  tokenApi,
  fetchExternal,
  getSecureTimeoutMs,
  getGeoIpUrl,
  getDataTransactionUrl,
  getRouteEmailUrl,
};
